export const url = {
  // Pages
  home: '/',
  ourMission: '/our-mission',
  getInvolved: '/get-involved',
  commitments: '/commitments',
  donate: '/donate',
  request: '/request',
}
